// src/pages/Accounts/expenseThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getExpenseWithDetailsApi,
  getExpenseCodeApi,
  saveExpenseApi,
  deleteExpenseApi,
  getAccountBalanceApi,
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

// fetch list (with details)
export const fetchExpenses = createAsyncThunk(
  "expenses/fetchExpenses",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getExpenseWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch new expense code
export const fetchExpenseCode = createAsyncThunk(
  "expenses/fetchExpenseCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getExpenseCodeApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchHeadAccs = createAsyncThunk(
  "lookups/fetchHeadAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
      multiType: ["indirect_expense", "direct_expense"],
    });     
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// save expense (create / update)
export const saveExpense = createAsyncThunk(
  "expenses/saveExpense",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveExpenseApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete expense
export const deleteExpense = createAsyncThunk(
  "expenses/deleteExpense",
  async (exp_id, { rejectWithValue }) => {
    try {
      const res = await deleteExpenseApi({ exp_id });
      return { id: exp_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


